import React from 'react'
import { Link } from 'react-router-dom'
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineEmail, MdOutlinePhone } from "react-icons/md";
import { FaArrowRightLong } from "react-icons/fa6";

const SupportCall = () => {
  return (
    <div>
       <div className="breadcrumb_sec">
        <div className="container">
            <nav>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to='my-account'>My Account</Link>
                    </li>
                    <li className="breadcrumb-item">Support
                        Call
                    </li>
                </ol>
            </nav>
            <div className="support pb-3">
                <h3>Support Call</h3>
                <p>Connect with our dedicated support for quick resolutions.</p>
            </div>
        </div>
    </div>

    <div className="support_call_section pt-5 pb-5">
        <div className="container">
            <div className="row">
                <div className="col-xl-12">
                    <div
                        className="support_box overflow-hidden position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                            <div className="d-flex align-items-center">
                                <div className="me-2 icon">
                                    <Link to='' className="stretched-link">
                                        <FaWhatsapp/>
                                    </Link>
                                </div>
                                <div>
                                    <h5>Connect on Whatsapp</h5>
                                    <p>on 8547563254</p>
                                </div>
                            </div>
                        </div>
                        <div className="item-2">
                            <div className="arrow-right">
                                <FaArrowRightLong/>
                            </div>
                        </div>
                    </div>
                    <div
                        className="support_box overflow-hidden position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                            <div className="d-flex align-items-center">
                                <div className="me-2 icon">
                                    <Link to='' className="stretched-link">
                                       <MdOutlineEmail/>
                                    </Link>
                                </div>
                                <div>
                                    <h5>Send us an Email</h5>
                                    <p>at contact@gmail.com</p>
                                </div>
                            </div>

                        </div>
                        <div className="item-2">
                            <div className="arrow-right">
                                <FaArrowRightLong/>
                            </div>
                        </div>
                    </div>
                    <div
                        className="support_box overflow-hidden position-relative d-flex align-items-center justify-content-between">
                        <div className="item-1">
                            <div className="d-flex align-items-center">
                                <div className="me-2 icon">
                                    <Link to='' className="stretched-link">
                                        <MdOutlinePhone/>
                                    </Link>
                                </div>
                                <div>
                                    <h5>Get on call with us</h5>
                                    <p>on 8547563254</p>
                                </div>
                            </div>

                        </div>
                        <div className="item-2">
                            <div className="arrow-right">
                                <FaArrowRightLong/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    </div>
  )
}

export default SupportCall
